import Http from '@/services/httpAcademy'

export const listReviews = (params) =>
	Http.get('/admin/reviews', { params })

export const approveReview = ({ id }) =>
	Http.patch(`/admin/reviews/${id}/approve`)

export const rejectReview = ({ id, reason }) =>
	Http.patch(`/admin/reviews/${id}/reject`, { reason })
